'use strict';
import angular from 'angular';

import googleAdsLocatioHtmlUrl from './views/geoTargetingGoogle.list.html';

var app = angular.module('app.geoTargetingGoogle.component', []);

app.component('geoTargetingGoogle', {
    bindings: {
        selectedGeoLocations: '=',
        clusterId: '=',
        showActions: '=',
        isEditForm:'='
    },
    templateUrl: googleAdsLocatioHtmlUrl,

    // The controller that handles our component logic
    controller: function ($scope, $ioAlert, anchorSmoothScroll, $location, $timeout, $stateParams, FormService, ClusterService,$modal,ModalService) {
        var self = this;
        self.orderId = $stateParams.orderId;
        self.rootLocation = { "id": 0, "children": "1", "criteria": "" };
        self.navAdwordsLocations = [];
        self.previousLocationData = [];
        self.geolocSearch = "";
        self.breadcrumbs = [];
        self.collectedNodes = [0];
        self.includeOrExcludeLocation = null;
        var geoLocationsCount = 0;
        self.showTabPanel = true;

        self.geoTextInputs = {
            inputValues: ''
        }
        self.selectedInput = {
            value: 'geo-loc_locations'
        }
        self.textInputOptions = ["Postal Codes", "States", "Cities"];
        self.textInputObj = {
            textInputType: "Postal Codes"
        }
        self.selectedCriteria = {
            criteria: ""
        };
        self.criteria = ["include all", "exclude all"];
        self.showError = false;
        self.toggleComponent = function (selectedOption) {
            self.selectedInput.value = selectedOption;
        }
        $scope.$watch('$ctrl.geoTextInputs.inputValues', function () {
            if (self.geoTextInputs.inputValues.length == 0) {
                self.showError = false;
            }
        });

        $scope.$watchCollection('$ctrl.selectedGeoLocations.selAdwordsLocationPickers', function (newCol, oldCol, scope) {
            self.selectedListOfLocations = self.selectedListOfLocations || [];
            _.map(newCol, function (item) {
                item.selectedInput = "geo-loc_textInput";
                self.selectedListOfLocations.push(item)
            })
            self.selectedListOfLocations  = _.uniq(self.selectedListOfLocations);
        })

        $scope.$watchCollection('$ctrl.selectedGeoLocations.selTextInputs', function (newCol, oldCol, scope) {
            self.selectedListOfLocations = self.selectedListOfLocations || [];
            _.map(newCol, function (item) { self.selectedListOfLocations.push(item) })
            self.selectedListOfLocations = _.uniq(self.selectedListOfLocations);
        })

        self.handleChangeTextInput = function () {
            self.geoTextInputs.inputValues = '';
            self.showError = false;
        }


        self.getLocationTooltips = function (locations) {
            var data = angular.copy(locations);
            data = data.slice(2);
            var html = angular.element("<ul/>");
            angular.forEach(data, function (item) {
                html.append("<li style='list-style:none;'>" + item.full_name + "</li>");
            });
            return html.html();

        };


        self.handleClearSelectedLocations = function () {
            self.selectedGeoLocations.selAdwordsLocationPickers = [];
            self.selectedGeoLocations.selTextInputs = [];
            self.selectedListOfLocations = [];
            self.selectedCriteria.criteria = 'none';
            geoLocationsCount = 0;
            self.includeOrExcludeLocation = null;
            _.each(self.navAdwordsLocations, function (navLocation) {
                navLocation.criteria = '';
                navLocation.criteria_link = 'include';
            });
        }

        self.handleChangeCriteria = function () {
            self.selectedGeoLocations.selAdwordsLocationPickers = [];
            if (self.selectedCriteria.criteria == 'include all') {
                _.each(self.navAdwordsLocations, function (navLocation) {
                    navLocation.criteria = 'include';
                    navLocation.criteria_link = 'included';
                    navLocation.full_name = self.buildFullName(navLocation);
                    self.selectedGeoLocations.selAdwordsLocationPickers.push(navLocation);
                });
            } else if (self.selectedCriteria.criteria == 'exclude all') {
                _.each(self.navAdwordsLocations, function (navLocation) {
                    navLocation.criteria = 'exclude';
                    navLocation.criteria_link = 'excluded';
                    navLocation.full_name = self.buildFullName(navLocation);
                    self.selectedGeoLocations.selAdwordsLocationPickers.push(navLocation);
                });
            } else {
                _.each(self.navAdwordsLocations, function (navLocation) {
                    navLocation.criteria = '';
                    navLocation.criteria_link = 'include';
                });
            }
        }

        self.getChildrenNodes = function (item) {
            if (item.children > 0) {
                if (self.collectedNodes.indexOf(item.id) < 0) {
                    FormService.getAdwordsLocationsById(item.id).then(function (success) {
                        self.collectedNodes.push(item.id);
                        self.locations = self.locations.concat(success);
                        self.getLocationChilds(item);
                        self.geolocSearch = "";
                    }, function (error) {
                        $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
                    });
                } else {
                    self.getLocationChilds(item);
                }
            }
        };

        self.showtabPanel = function () {
            self.showTabPanel = !self.showTabPanel;
        }

        self.getLocationChilds = function (item) {
            if (item.children > 0) {
                self.navAdwordsLocations = [];
                if (self.locations) {
                    for (var i = 0, len = self.locations.length; i < len; i++) {
                        if (self.locations[i].parent_id == item.id) {
                            if (self.selectedGeoLocations.selAdwordsLocationPickers.length > 0) {
                                var selIndex = _.findIndex(self.selectedGeoLocations.selAdwordsLocationPickers, { id: self.locations[i].id });
                                if (selIndex !== -1) {
                                    self.locations[i].criteria = self.selectedGeoLocations.selAdwordsLocationPickers[selIndex].criteria;
                                    self.includeOrExcludeLocation = self.selectedGeoLocations.selAdwordsLocationPickers[selIndex].criteria + 'location';
                                }
                            } else {
                                self.locations[i].criteria = "";
                            }
                            if (self.locations[i].criteria.length == 0 && item.criteria.length > 0) {
                                self.locations[i].criteria = item.criteria;
                            }
                            self.locations[i].criteria_link = 'include';
                            if (self.locations[i].criteria == "include") {
                                self.locations[i].criteria_link = 'included';
                            } else if (self.locations[i].criteria == "exclude") {
                                self.locations[i].criteria_link = 'excluded';
                            }
                            self.navAdwordsLocations.push(self.locations[i]);
                            self.checkingCriteria();
                        }
                    }
                    self.previousLocationData = angular.copy(self.navAdwordsLocations);
                }
                self.breadcrumbs = [];
                self.buildBreadcrumbs(item);
            }
        }

        self.changeIncludeExclude = function (item, criteria) {
            var index = self.navAdwordsLocations.indexOf(item);
            if (index >= 0) {
                if (criteria == "include") {
                    self.navAdwordsLocations[index].criteria = 'include';
                    self.navAdwordsLocations[index].criteria_link = 'included';
                } else if (criteria == "exclude") {
                    self.navAdwordsLocations[index].criteria = 'exclude';
                    self.navAdwordsLocations[index].criteria_link = 'excluded';
                } else {
                    self.navAdwordsLocations[index].criteria = '';
                    self.navAdwordsLocations[index].criteria_link = 'include';
                }
                if (geoLocationsCount < 1) {
                    self.includeOrExcludeLocation = criteria + 'location';
                }
                var selIndex = _.findIndex(self.selectedGeoLocations.selAdwordsLocationPickers, { id: self.navAdwordsLocations[index].id });
                self.navAdwordsLocations[index].full_name = self.buildFullName(self.navAdwordsLocations[index])
                if (selIndex >= 0) {
                    self.selectedGeoLocations.selAdwordsLocationPickers[selIndex] = self.navAdwordsLocations[index];
                } else {
                    self.selectedGeoLocations.selAdwordsLocationPickers.push(self.navAdwordsLocations[index]);
                }
                changeAllChildCriteria(self.navAdwordsLocations[index].id, self.navAdwordsLocations[index].criteria);
                for (var i = 0; i < self.selectedGeoLocations.selAdwordsLocationPickers.length; i++) {
                    var parentId = parseInt(self.selectedGeoLocations.selAdwordsLocationPickers[i].parent_id);
                    var parentObj = _.find(self.locations, { id: parentId });

                    if (parentObj && parentObj.criteria === self.selectedGeoLocations.selAdwordsLocationPickers[i].criteria) {
                        self.selectedGeoLocations.selAdwordsLocationPickers.splice(i, 1);
                    }
                }
                geoLocationsCount++;
            }
        }

        /*
        * Handle validate postal codes, cities and states
        */
        self.validateInputValues = function () {
            var typeMap = {
                "Postal Codes": "POSTAL_CODE",
                "States": "STATE",
                "Cities": "CITY"
            };

            var selectedType = typeMap[self.textInputObj.textInputType];
            if (!selectedType) {
                $ioAlert.show('Error!', 'Invalid location type selected.', 'error');
                return;
            }

            var geoValues = self.geoTextInputs.inputValues.replace(/\n/g, ",").split(",");
            var filteredValues = geoValues.filter(function (el) {
                return el.trim() !== "";
            });

            var operation = 'operation_validate_geo';

            FormService.validateBulkGoogleLocations(selectedType, filteredValues, operation).then(function (data) {
                if (data) {
                    processTextInputs(data.data);
                }
            }, function (error) {
                $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
            });
        };

        var processTextInputs = function(response) {
            (self.selectedGeoLocations ??= {}).selTextInputs ??= [];
            if(response.valid && response.valid.length > 0) {
                _.each(response.valid, function(validGeoValue) {
                    validGeoValue.geoType = self.textInputObj.textInputType;
                    validGeoValue.criteria_link = 'included';
                    self.selectedGeoLocations.selTextInputs.push(validGeoValue);
                })
                self.geoTextInputs.inputValues = '';
            }

            if(response.invalid && response.invalid.length > 0){
                self.showError = true;
                self.geoTextInputs.inputValues = response.invalid.toString();
            }
        }

        self.removeLoc = function (item) {
            if (item.selectedInput == "geo-loc_textInput") {
                var selIndex = self.selectedGeoLocations.selAdwordsLocationPickers.indexOf(item);
                if (selIndex >= 0) {
                    self.selectedGeoLocations.selAdwordsLocationPickers.splice(selIndex, 1);
                    if (self.selectedGeoLocations.selAdwordsLocationPickers.length == 0) {
                        geoLocationsCount = 0;
                        self.includeOrExcludeLocation = null;
                    }
                }
                var parentId = parseInt(item.parent_id);
                var parentLocation = _.find(self.locations, { id: parentId });
                var locationObj = _.find(self.locations, { id: item.id });
                if (locationObj) {
                    if (parentLocation) {
                        if (parentLocation.criteria == "include") {
                            locationObj.criteria = 'include';
                            locationObj.criteria_link = 'included';
                        } else if (parentLocation.criteria == "exclude") {
                            locationObj.criteria = 'exclude';
                            locationObj.criteria_link = 'excluded';
                        } else {
                            locationObj.criteria = '';
                            locationObj.criteria_link = 'include';
                        }
                    } else {
                        locationObj.criteria = '';
                        locationObj.criteria_link = 'include';
                        for (var k = 0; k < self.navAdwordsLocations.length; k++) {
                            if (self.navAdwordsLocations[k].name == item.name) {
                                self.navAdwordsLocations[k].criteria = '';
                                self.navAdwordsLocations[k].criteria_link = 'include';
                                break;
                            }
                        }
                        self.previousLocationData = angular.copy(self.navAdwordsLocations);
                    }
                    changeAllChildCriteria(item.id, locationObj.criteria);
                } else {
                    for (var k = 0; k < self.navAdwordsLocations.length; k++) {
                        if (self.navAdwordsLocations[k].name == item.name) {
                            self.navAdwordsLocations[k].criteria = '';
                            self.navAdwordsLocations[k].criteria_link = 'include';
                            break;
                        }
                    }
                }
                for (var i = 0; i < self.selectedGeoLocations.selAdwordsLocationPickers.length; i++) {
                    if (self.selectedGeoLocations.selAdwordsLocationPickers[i].parent_id == String(item.id)) {
                        self.selectedGeoLocations.selAdwordsLocationPickers.splice(i, 1);
                    }
                }
            } else {
                var selIndex = _.findIndex(self.selectedGeoLocations.selTextInputs, {id: item.id});
                if (selIndex >= 0) {
                    self.selectedGeoLocations.selTextInputs.splice(selIndex, 1);
                    self.selectedListOfLocations.splice(self.selectedListOfLocations.indexOf(item),1)
                }
            }
        }

        function changeAllChildCriteria(parentId, criteria = "") {
            _.each(self.locations, function (location) {
                if (location.parent_id == parentId) {
                    if (criteria == "include") {
                        location.criteria = 'include';
                        location.criteria_link = 'included';
                    } else if (criteria == "exclude") {
                        location.criteria = 'exclude';
                        location.criteria_link = 'excluded';
                    } else {
                        location.criteria = '';
                        location.criteria_link = 'include';
                    }
                    changeAllChildCriteria(location.id, location.criteria);
                }
            });
        }

        //searching loacgtion by Searvices
        self.searchAdwordsLocation = function (geolocSearch) {
            if (event.keyCode != 13) {
                if (geolocSearch.length >= 3) {
                    FormService.getAdwordsSearchloctions(geolocSearch).then(function (success) {
                        if (success && success.length > 0) {
                            self.searchData = success;
                            self.navAdwordsLocations = [];
                            _.each(self.searchData, function (item, i) {
                                var index = self.locations.findIndex(x => x.id == item.id);
                                if (index > -1) {
                                    self.navAdwordsLocations.push(self.locations[index]);
                                }
                                else {
                                    self.navAdwordsLocations[i] = item;
                                    self.navAdwordsLocations[i].criteria = "";
                                    self.navAdwordsLocations[i].criteria_link = 'include';
                                    self.navAdwordsLocations[i].name = item.name;
                                    self.navAdwordsLocations[i].parent_name = item.parent_name;
                                    self.navAdwordsLocations[i].state_name = item.state_name;
                                }
                            });
                            self.checkingCriteria();
                        }
                    }, function (error) {

                    });
                } else {
                    if (geolocSearch.length == 0) {
                        self.searchData = [];
                        self.navAdwordsLocations = [];
                        self.navAdwordsLocations = angular.copy(self.previousLocationData);
                        self.checkingCriteria();
                    }
                }
            }
            else if (event.keyCode == 8) {
                if (geolocSearch.length == 0) {
                    self.searchData = [];
                    self.navAdwordsLocations = [];
                    self.navAdwordsLocations = angular.copy(self.previousLocationData);
                    self.checkingCriteria();
                }
            }
        }
        self.checkingCriteria = function () {
            for (var k = 0; k < self.selectedGeoLocations.selAdwordsLocationPickers.length; k++) {
                for (var j = 0; j < self.navAdwordsLocations.length; j++) {
                    if (self.selectedGeoLocations.selAdwordsLocationPickers[k].name == self.navAdwordsLocations[j].name) {
                        if (self.selectedGeoLocations.selAdwordsLocationPickers[k].criteria == "include") {
                            self.navAdwordsLocations[j].criteria = 'include';
                            self.navAdwordsLocations[j].criteria_link = 'included';
                        } else if (self.selectedGeoLocations.selAdwordsLocationPickers[k].criteria == "exclude") {
                            self.navAdwordsLocations[j].criteria = 'exclude';
                            self.navAdwordsLocations[j].criteria_link = 'excluded';
                        } else {
                            self.navAdwordsLocations[j].criteria = '';
                            self.navAdwordsLocations[j].criteria_link = 'include';
                        }
                    }
                }
            }
        }

        self.buildBreadcrumbs = function (item) {
            if (item.parent_id || item.parent_id == 0) {
                self.breadcrumbs.unshift(item);
                if (item.parent_id == 0) {
                    return false;
                } else {
                    var obj = _.find(self.locations, function (loc) {
                        return loc.id == item.parent_id
                    });
                    self.buildBreadcrumbs(obj);
                }
            }
        }

        self.buildFullName = function (item) {
            if (!item) return '';
            if (item.parent_id == 0) {
                if (item.type === 'STATE' && item.state_name) {
                    return item.state_name;
                }
                return item.name;
            }
            var parent = _.find(self.locations, function (loc) {
                return loc.id == item.parent_id;
            });
            if (!parent && item.parent_name) {
                if (item.state_name) {
                    return item.name + ', ' + item.state_name + ', ' + item.parent_name;
                }
                return item.name + ', ' + item.parent_name;
            }
            if (item.state_name) {
                return item.name + ', ' + item.state_name + ', ' + self.buildFullName(parent);
            }
            return item.name + ', ' + self.buildFullName(parent);
        };



        self.openHelperTextPopup = function(){
            $modal.open(
                ModalService.returnModalType('showHelpertexts')
            ).result.then(function (res) {
                var test = res;
            });
        }

        var getLocations = function () {
            FormService.geoLocationsForAdwords(0).then(function (success) {
                self.locations = success;
                self.getLocationChilds(self.rootLocation);
            }, function (error) {
                $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
            });
        };

        var initLocations = function () {
            if (self.selectedGeoLocations && !_.isEmpty(self.selectedGeoLocations)) {
                self.selectedGeoLocations = JSON.parse(self.selectedGeoLocations);
                if (self.showActions) {
                    self.editMode = true;
                    self.enableViewMode = false;
                    getLocations();
                } else {
                    self.editMode = false;
                    self.enableViewMode = true;
                }
            } else {
                self.selectedGeoLocations = {
                    selAdwordsLocationPickers: [],
                    enableBidAmount: false
                };
                self.enableViewMode = false;
                self.editMode = false;
                getLocations();
            }
        };

        initLocations();
    }
});